<template>
  <div class="courseDetail">
    <div class="content">
      <div class="navtitle">
        <div class="breadCrumb">
          <span @click="returnHome()">首页 ></span>
          <span @click="returncourse()">课程中心 ></span>
          <span>{{ list.title }}</span>
        </div>
        <!-- <div class="backbtn" @click="toback">
          <span></span>
          <span>返回</span>
        </div> -->
      </div>
      <courseItem
        :list="list"
        @logup="logup" 
        @signup="signup"
        @tocollect="tocollect"
        @tostudy="tostudy"
        :taskId="taskId"
      ></courseItem>
      <div class="detail">
        <div class="left" :style="{ width: widthClass + 'px' }">
          <ul class="title">
            <li
              v-for="(item, index) in menuList"
              :key="index"
              @click="changePage(item)"
              :class="{ active: current == item }"
            >
              {{ item }}
            </li>
          </ul>
          <div class="inner">
            <router-view></router-view>
          </div>
        </div>
        <div class="right">
          <div class="top">
            <img src="../assets/course/teacherLogo.png" alt="" />
            讲师: {{ list.teacher }}
          </div>
          <div class="bottom">
            <template v-if="list.teacherInfo">
              {{ list.teacherInfo }}
            </template>
            <!-- <template v-else>
              <img
                src="../assets/course/teacherinfo.png"
                alt=""
              >
              <p class="inp">暂无教师简介</p>
            </template> -->
            <div class="notbox" v-else>
              <img src="../assets/blank/notteacher.png" alt="" />
              <p class="inp">暂无教师简介</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popBox
      :isBox="isBox"
      @closemodal="closemodal"
      @sureModal="sureModal"
    ></popBox>
    <loginModal
      :isShow="isShow"
      @closemodal="isShow = false"
      @logined="logined"
      @goregister="goregister"
      @forget="forget"
    ></loginModal>
    <!-- 返回顶部按钮 -->
    <div class="gohead" v-show="showhead">
      <a href="#layout"></a>
    </div>
  </div>
</template>

<script>
import {
  getcourseDetailApi,
  joincourseApi,
  getcollectApi,
  getcontinueApi,
  getupdateStatusApi,
} from "@/request/api";
import courseItem from "@/components/common/courseItem";
import loginModal from "@/components/common/loginModal";
import popBox from "@/components/common/popBox";
export default {
  name: "courseDetail",
  components: { courseItem, loginModal, popBox },
  data() {
    return {
      menuList: ["课程简介", "课程目录", "课程问答"],
      current: null,
      Id: null,
      taskId: null,
      list: {},
      courseId: null,
      isShow: false,
      isBox: false,
      widthClass: 933,
      isexit: true,
      joined: "",
      title: "",
      showhead: false,
      chapterId: "",
      info: {
        courseId: "",
        collected: "",
      },
    };
  },
  created() {
    this.Id = JSON.parse(this.$Base64.decode(this.$route.query.id));
    // this.$router.push({ query: {} });
    this.init();
    this.$store.commit("changeCourseStatus", { isJoined: false });
  },
  watch: {
    isLogin: function () {
      this.init();
    },
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
    let arr = window.location.pathname.split("/");
    switch (arr[arr.length - 1]) {
      case "courseInfo":
        this.current = "课程简介";
        break;
      case "catalog":
        this.current = "课程目录";
        break;
      case "answer":
        this.current = "课程问答";
        break;
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    role() {
      return this.$store.state.role;
    },
  },

  methods: {
    init() {
      this.getToken(getcourseDetailApi, { courseId: this.Id }, (res) => {
        this.list = res.data;
        this.joined = res.data.joined;
      });
    },
    returnHome() {
      this.$router.push({ path: "/" });
    },
    returncourse() {
      this.$router.push({ path: "/Course" });
    },
    changePage(data) {
      this.current = data;
      let path = "";
      switch (data) {
        case "课程简介":
          path = "/courseInfo";
          break;
        case "课程目录":
          path = "/catalog";
          break;
        case "课程问答":
          path = "/answer";
          break;
      }
      this.$router.push({
        path: path,
        query: {
          id: this.$Base64.encode(this.Id),
          joined: this.$Base64.encode(this.joined),
        },
      });
    },
    logined() {
      this.isShow = false;
      this.init();
    },
    logup(isLogin) {
      if (isLogin == 0) {
        this.isShow = false;
        this.init();
      } else {
        this.isShow = true;
        this.init();
      }
    },
    signup(id) {
      joincourseApi({ courseId: id }).then((res) => {
        if (res.code == 426) {
          this.isBox = true;
        } else if (res.code == 200) {
          this.$message.success("加入成功，请开始学习吧！");
          this.$store.commit("changeCourseStatus", { isJoined: true });
          this.isBox = false;
          this.init();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    closemodal() {
      this.isBox = false;
    },
    sureModal() {
      this.isBox = false;
    },
    tocollect(isLogin) {
      if (isLogin == 0) {
        this.list.collected = !this.list.collected;
        this.info.collected = this.list.collected;
        this.info.courseId = this.Id;
        this.getToken(getcollectApi, this.info, () => {
          this.init();
        });
      } else {
        this.$message.error("您还没有登录");
        this.init();
      }
    },
    //开始学习，继续学习
    tostudy(id) {
      this.getToken(getcontinueApi, { courseId: id }, (res) => {
        //判断是否是资料
        if (res.data.type == 1) {
          //点击改变状态

          this.getToken(
            getupdateStatusApi,
            { courseId: this.Id, taskId: res.data.id, status: 1 },
            () => {
              this.$store.commit("getIds", {
                chapterId: this.chapterId,
                taskId: res.data.id,
              });
              this.$router.push({
                path: "/catalogDetail",
                query: {
                  id: this.$Base64.encode(id),
                  menuId: this.$Base64.encode(res.data.id),
                  paperId:res.data.paperId?this.$Base64.encode(res.data.paperId):null,
                  resourceUrl:res.data.resourceUrl?(this.$Base64.encode(res.data.resourceUrl)):null
                },
              });
            }
          );
        } else {
          this.$router.push({
            path: "/catalogDetail",
            query: {
              id: this.$Base64.encode(id),
              menuId: this.$Base64.encode(res.data.id),
              paperId:this.$Base64.encode(res.data.paperId),
              paperId:res.data.paperId?this.$Base64.encode(res.data.paperId):null,
              resourceUrl:res.data.resourceUrl?(this.$Base64.encode(res.data.resourceUrl)):null

            },
          });
        }
      });
    },
    goregister() {
      this.$router.push({ path: "/register" }); //点击登录页的去注册
      this.isShow = false;
    },
    forget() {
      this.$router.push({ path: "/forgetModal" }); //点击登录页的忘记密码
      this.isShow = false;
    },
    //实现回到顶部
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 100) {
        this.showhead = true;
      } else {
        this.showhead = false;
      }
    },
    // toback() {
    //   this.$router.back(-1);
    // },
    // beforeRouteLeave(to, from, next) {
    //   //设置下一个路由的meta,让列表页面缓存,即不刷新
    //   to.meta.keepAlive = true;
    //   next();
    // },
  },
};
</script>
<style lang="stylus" scoped>
.ql-editor {
  padding: 0px 0px;
}
</style>
<style lang="stylus" scoped>
.courseDetail {
  background: #eee;

  .content {
    width: 1205px;
    margin: 0 auto;
    min-height: 500px;
    overflow: hidden;

    .navtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 22px;
      margin-bottom: 24px;

      .breadCrumb {
        height: 20px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;

        span:hover {
          color: #f0cd48;
          cursor: pointer;
        }

        span:last-child {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          letter-spacing: 1px;
          color: #999999;
          cursor: default;
        }
      }

      .backbtn {
        display: flex;
        justify-content: center;
        align-items: center;

        span:nth-child(1) {
          display: block;
          width: 21px;
          height: 21px;
          background: url('../assets/simulation/back.png');
        }

        span:nth-child(2) {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #333333;
          margin-left: 5px;
        }
      }

      .backbtn:hover {
        cursor: pointer;

        span:nth-child(2) {
          color: #ef9545;
        }

        span:nth-child(1) {
          background: url('../assets/simulation/back1.png');
        }
      }
    }

    .detail {
      margin-top: 20px;
      overflow: hidden;

      .left {
        width: 930px;
        float: left;
        background: #fff;
        min-height: 300px;
        margin-bottom: 18px;

        .title {
          height: 53px;
          display: flex;
          padding-left: 29px;

          li {
            margin-right: 60px;
            height: 50px;
            line-height: 53px;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 70px;
            letter-spacing: 0px;
            color: #333333;
            text-align: center;
            cursor: pointer;
          }

          li:last-child {
            margin-right: 0px;
          }

          .active {
            color: #eab900;
            border-top: 2px solid #f0cd48;
          }
        }

        .inner {
          padding-left: 29px;
          margin-top: 25px;
          padding-right: 30px;
          margin-bottom: 30px;
        }
      }

      .right {
        padding: 0 30px;
        width: 251px;
        float: right;
        background: #fff;
        min-height: 300px;

        .top {
          border-bottom: 1px solid #ddd;
          height: 85px;
          display: flex;
          align-items: center;
          color: #666;

          img {
            margin-right: 25px;
          }
        }

        .bottom {
          margin-top: 30px;
          color: #666;
          line-height: 24px;
          padding-bottom: 20px;

          .notbox {
            margin: 0 auto;
            margin-bottom: 30px;
            margin-top: 40px;
            text-align: center;

            img {
              display: block;
              margin: 0 auto;
            }

            .inp {
              font-size: 18px;
              color: #666;
              margin: 0 auto;
              text-align: center;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}

.gohead {
  width: 66px;
  height: 58px;
  background-color: #f9f9fa;
  border-radius: 3px;
  border: solid 1px #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 240px;
  bottom: 50px;
  cursor: pointer;

  a {
    width: 33px;
    height: 32px;
    display: inline;
    text-align: center;
    background: url('../assets/home/gohead3.png') -18px -15px no-repeat;
  }
}

.gohead:hover {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}

.gohead:active {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}
</style>
